export const getUserLocation = (onSuccess, onError) => {
    navigator.geolocation.getCurrentPosition(
        (position) => {
            onSuccess({
                lat: position.coords.latitude,
                lng: position.coords.longitude
            });
        },
        (error) => {
            onError(null); // or onError(error)
        }
    );
};
